import { DynamicTableHelper } from "@workspace/common";
import { ArrayHelper } from "@workspace/common";

export const JOB_MANDATORY_OPTIONS = [
  {
    sortValue: "job_submission_data.jobId",
    label: "Pulse Job Id",
    value: "jobSubmissionData.jobId",
    sort: true,
    expand: true,
  },
  {
    sortValue: "job_submission_data.jobTitle",
    label: "Job Title",
    value: "jobSubmissionData.jobTitle",
    sort: true,
    expand: true,
  },
  {
    sortValue: "recruiterName",
    label: "Recruiter(s)",
    value: "recruiterName",
    sort: true,
    expand: true,
  },
];

export const JOB_INITIAL_OPTIONS = [
  {
    sortValue: "job_submission_data.jobType",
    label: "Job Type",
    value: "jobSubmissionData.jobType",
    sort: true,
  },
  {
    sortValue: "job_submission_data.dateOpen",
    label: "Date Open",
    value: "jobSubmissionData.dateOpen",
    sort: true,
  },
  {
    sortValue: "job_submission_data.accountOwner",
    label: "Account Owner",
    value: "jobSubmissionData.accountOwner",
    sort: true,
  },
  {
    sortValue: "job_submission_data.secondaryOwner",
    label: "Secondary Owner",
    value: "jobSubmissionData.secondaryOwner",
    sort: true,
  },
  {
    sortValue: "job_submission_data.accountName",
    label: "Account Name",
    value: "jobSubmissionData.accountName",
    sort: true,
  },
  {
    sortValue: "job_submission_data.accountContact",
    label: "Account Contact",
    value: "jobSubmissionData.accountContact",
    sort: true,
  },
  {
    sortValue: "job_submission_data.workLocation",
    label: "Work Location",
    value: "jobSubmissionData.workLocation",
    sort: true,
  },
  {
    sortValue: "job_submission_data.noofheadcounts",
    label: "No. Of Headcounts",
    value: "jobSubmissionData.noofheadcounts",
    sort: true,
  },
];

export const JOB_MAIN_FIELDS = [
  {
    label: "Created By",
    value: "createdByName",
    sort: true,
    sortValue: "createdByName",
  },
  {
    label: "Updated By",
    value: "updatedByName",
    sort: true,
    sortValue: "updatedByName",
  },
  {
    label: "Created At",
    value: "createdAt",
    sort: true,
    sortValue: "created_at",
  },
  {
    label: "Updated At",
    value: "updatedAt",
    sort: true,
    sortValue: "updated_at",
  },
  {
    sortValue: "recruiterName",
    label: "Recruiter(s)",
    value: "recruiterName",
    sort: true,
  },
];

export const generateJobFields = (jobForm) => {
  const fields = [...JOB_MAIN_FIELDS];

  if (jobForm) {
    const jobOptions = DynamicTableHelper.buildOptionsArray(
      jobForm?.formSchema,
      "jobSubmissionData",
      "job_submission_data",
      "Job"
    );
    fields.push(...jobOptions);
  }

  // Remove duplicate value in the object of array. Keep the first
  const fieldsNew = fields.filter(
    (field, index, self) =>
      index === self.findIndex((t) => t.value === field.value)
  );

  ArrayHelper.sortArrayObjIcase(fieldsNew, "label");

  return fieldsNew;
};
